<template lang="html">
  <div class="description van-hairline--top van-hairline--bottom">
    {{content}}
  </div>
</template>

<script>
  export default {
    props: {
      content: String
    }
  }
</script>

<style lang="css" scoped>
  .description {
    background: #fff;
    padding: 16px;
    font-size: 0.93em;
    color: #666;
    white-space: pre-wrap;
  }
</style>
